import { INVITE_CODE as localStorageKey } from '../KEYS';

export default {
  get(): string | null {
    return localStorage.getItem(localStorageKey);
  },

  set(value: string) {
    localStorage.setItem(localStorageKey, value);
  },

  clear() {
    localStorage.removeItem(localStorageKey);
  },
};
